module.exports = __webpack_public_path__ + "assets/b40.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b40.png
// module id = 628
// module chunks = 0